import { CatalogItem } from '../../../redux/api/fymAPI.types';
import { catalogArtworkSrc, CatalogArtworkSource } from '../catalog/catalogArtwork';

/**
 * The cover the sheet shows for its release.
 *
 * The catalog row of the song wins: it holds the cover that the artist uploaded or made in the
 * cover editor, and the new page uses that cover too. An unreleased row resolves to no links, so
 * the resolution has no picture for it. The picture of the resolution (a streaming service) is
 * only the fallback for a release with no catalog row or a row with no cover.
 */
export function creationCoverUrl(
  catalogRow: CatalogArtworkSource | undefined,
  resolutionImageUrl: string | undefined
): string | undefined {
  const rowCover = catalogRow === undefined ? undefined : catalogArtworkSrc(catalogRow, 96);
  if (rowCover !== undefined && rowCover !== '') {
    return rowCover;
  }
  return resolutionImageUrl === '' ? undefined : resolutionImageUrl;
}

/**
 * The catalog row as the cache holds it now.
 *
 * The sheet stores the row it was opened on. A cover made in the editor (a new tab) or a change
 * from another device reaches the catalog cache through the realtime event, so the sheet reads the
 * row again by its uuid. The stored copy is only the fallback while the list loads.
 */
export function liveCatalogRow(stored: CatalogItem, catalogItems: CatalogItem[]): CatalogItem {
  return catalogItems.find((item) => item.uuid === stored.uuid) ?? stored;
}
